import { Space, Button } from 'antd'
import useShowTransfersDetail from '../hooks/useShowTransfersDetail'
import AuthComponent from '../../../components/AuthComponent'
const basicModelOptions = {
  title: '详情'
}
export default function TransfersItemOperateOutBtns({record, getLog, getInWarehouse}) {
  const { showDetail } = useShowTransfersDetail()
  // 详情
  const getDetailShow = () => {
    showDetail(record.no, basicModelOptions, 'in')
  }
  return (
    <Space>
      {record.status === 'ON_THE_WAY' && (
        <>
          <AuthComponent authKey='/inventory/allocation/in/warehouse'>
            <Button type='link' size='small' onClick={()=>getInWarehouse(record.no)}>
              收货入库
            </Button>
          </AuthComponent>
        </>
      )}
      <AuthComponent authKey='/inventory/allocation/detail/{no}'>
        <Button type='link' size='small' onClick={getDetailShow}>
          详情
        </Button>
      </AuthComponent>
      <AuthComponent authKey='/inventory/allocation/operate/logs'>
        <Button type='link' size='small' onClick={()=>getLog(record.no, 'INWARD')}>
          操作日志
        </Button>
      </AuthComponent>
    </Space>
  )
}
